import { evaluate } from '../dsl/evaluator'
import { adwinProgram } from '../dsl/programs'

export default {
  key: 'adwin',
  title: 'Đỉnh-Đáy',

  xLabel: 'Thay đổi',
  yLabel: 'Đỉnh-Đáy',
  xUnit: '%',
  xRange: [-16, 16],
  yRange: [-200, 200],
  xStep: 2,
  yStep: 50,

  xHighlights: [0],
  yHighlights: [0],

  zones: [
    {
      from: -200, to: -150, color: '#FF4C51AA', label: 'Hoảng loạn cực đại', labelColor: '#7A1F22',
    },
    {
      from: -150, to: -100, color: '#FF4C5155', label: 'Dễ hồi kỹ thuật', labelColor: '#A02D30',
    },
    {
      from: -100, to: 0, color: '#FFB40033', label: 'Yếu - Chán nản', labelColor: '#806000',
    },
    {
      from: 0, to: 100, color: '#FFB40033', label: 'Vùng an toàn', labelColor: '#806000',
    },
    {
      from: 100, to: 150, color: '#56CA0055', label: 'Vùng hưng phấn', labelColor: '#3F9000',
    },
    {
      from: 150, to: 200, color: '#56CA00AA', label: 'Cảnh báo rủi ro', labelColor: '#2D6700',
    },
  ],

  compute(raw) {
    const {
      o = [], h = [], l = [], c = [], v = [], t = [],
    } = raw || {}
    if (!t.length) return { t: [], x: [], y: [] }

    const result = evaluate(adwinProgram, {
      open: o, high: h, low: l, close: c, volume: v,
    })

    const x = new Array(c.length)
    x[0] = 0
    for (let i = 1; i < c.length; i += 1) {
      const prev = c[i - 1]
      x[i] = prev ? ((c[i] / prev) - 1) * 100 : 0
    }

    return { t, x, y: result.adwinDoScope }
  },
}
